import * as actions from '../actions'
import * as storage from '../../utils/storage'

var defaultState = null

export default function api(state = defaultState, action) {
    switch (action.type) {

        case actions.API_CLEAN:
            return defaultState

        default:
            var newState = defaultState
            if (action.error) {
                newState = {}
                if (action.payload && action.payload.error && action.payload.error.status && action.payload.error.status === 401) {
                    storage.remove(storage.accessTokenKey)
                }
                if (action.payload && action.payload.error && action.payload.error.data && action.payload.error.data.error) {
                    newState.error = action.payload.error.data.error
                } else if (action.payload.error) {
                    newState.error = action.payload.error
                } else {
                    newState.error = action.payload
                }
                if (!newState.error) {
                    newState.error = 'Unexpected error'
                }
            }
            return newState
    }
}



// WEBPACK FOOTER //
// ./state/reducers/api.js